import React from "react";

// Elemento decorativo astratto — un ramo stilizzato, non foglia stock.
export default function BotanicalMark({ className = "", size = 120, opacity = 0.35 }) {
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <path
        d="M60 8 C 58 40, 55 70, 60 112"
        stroke="#8EA091"
        strokeWidth="0.8"
        fill="none"
      />
      {Array.from({ length: 8 }).map((_, i) => {
        const y = 22 + i * 10;
        const dir = i % 2 === 0 ? 1 : -1;
        return (
          <path
            key={i}
            d={`M60 ${y} Q ${60 + dir * 14} ${y + 4}, ${60 + dir * 22} ${y + 2}`}
            stroke="#8EA091"
            strokeWidth="0.6"
            fill="none"
            strokeLinecap="round"
          />
        );
      })}
    </svg>
  );
}
